import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Pharmacy } from '../_models/pharmacy.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class PharmacyService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getPharmaciesListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}&is_active=${filter.isActive}`;
    } else {
      if (filter.name) fromString += `&last_name_has=${filter.name}`;
      if (filter.email) fromString += `&email_has=${filter.email}`;
      if (filter.phone) fromString += `&phone_has=${filter.phone}`;
      if (filter.fax) fromString += `&fax_has=${filter.fax}`;
      if (filter.isActive) fromString += `&is_active=${filter.isActive}`;
    }

    return fromString;
  }

  createPharmacy(_pharmacy: Pharmacy) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacies`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Pharmacy>(url, _pharmacy, { headers });
  }

  findPharmacies(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: PharmacyService.getPharmaciesListQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(
      `${environment.CORE_BASE}/companies/${this.company_id}/pharmacies`,
      { params },
    );
  }
  

  updatePharmacy(_pharmacy: Pharmacy): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacies/${_pharmacy.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<Pharmacy>(url, _pharmacy, { headers });
  }

  deletePharmacy(pharmacyId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacies/${pharmacyId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  searchPharmacies(term: string): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacies`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams({ fromString: 'search_term=' + term });
    return this.http.get<QueryResultsModel>(url, { headers, params });
  }
}
